import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs';
import * as Bowser from 'bowser';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
const geolocation = {};
let geolocationObservable;
const REVERSE_GEOLOCATION_API_URL = 'https://maps.googleapis.com/maps/api/geocode/json?';
/** TODO:  Need to hide key */
const GOOGLE_MAP_API_KEY = 'AIzaSyAoRNJkxmsafbvw0w3Y1_biN8rOYMeuI-Y';
export class GeolocationService {
    constructor(http) {
        this.http = http;
    }
    getPosition() {
        return new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition(resp => {
                resolve({ lng: resp.coords.longitude, lat: resp.coords.latitude });
            }, err => {
                reject(err);
            });
        });
    }
    getUserLocation(callback) {
        this.getPosition().then(position => {
            if (position) {
                geolocationObservable = this.http
                    .get(REVERSE_GEOLOCATION_API_URL +
                    'latlng=' +
                    position.lat +
                    ',' +
                    position.lng +
                    '&key=' +
                    GOOGLE_MAP_API_KEY)
                    .pipe(map(data => data));
                geolocationObservable.subscribe(result => {
                    // eslint-disable-next-line no-constant-condition
                    if ((result.status = 'OK')) {
                        // get browser info
                        const browserInfo = Bowser.getParser(window.navigator.userAgent).getBrowser();
                        geolocation.browser = browserInfo.name + ' v.' + browserInfo.version.split('.')[0];
                        callback(this.parseLocation(result.results));
                    }
                    else {
                        callback(null);
                    }
                });
            }
            else {
                callback(null);
            }
        }, rejected => {
            // Delegate to ErrorHandler if error is not a GelocationPositionError OR if it is, but errir code is not 1 PERMISSION_DENIED
            if (!['GeolocationPositionError', 'PositionError'].includes(rejected.constructor.name) ||
                rejected.code !== 1) {
                throw rejected;
            }
        });
    }
    parseLocation(location) {
        location.forEach(function (element) {
            element.address_components.forEach(function (element2) {
                element2.types.forEach(function (element3) {
                    switch (element3) {
                        case 'postal_code':
                            geolocation.zip = element2.long_name;
                            break;
                        case 'administrative_area_level_1':
                            geolocation.state = element2.long_name;
                            break;
                        case 'locality':
                            geolocation.city = element2.long_name;
                            break;
                        case 'country':
                            geolocation.country = element2.long_name;
                            break;
                    }
                });
            });
        });
        return geolocation;
    }
    static { this.ɵfac = function GeolocationService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || GeolocationService)(i0.ɵɵinject(i1.HttpClient)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: GeolocationService, factory: GeolocationService.ɵfac }); }
}
//# sourceMappingURL=geolocation.service.js.map